var App = App || {};

App.Login = (function ($) {
    "use strict";

    function init() {
        ApplyCredentialStuffing();
    }

    function ApplyCredentialStuffing() {
        var usernameField = document.getElementById('user_id');
        var passwordField = document.getElementById('password');

        if (usernameField && passwordField) {
            usernameField.value = encodeURIComponent(usernameField.value);
            passwordField.value = encodeURIComponent(passwordField.value);
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Login.init();
});